import { render, staticRenderFns } from "./CustomsValueTopMenu.vue?vue&type=template&id=7ddc5971"
import script from "./CustomsValueTopMenu.vue?vue&type=script&lang=js"
export * from "./CustomsValueTopMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports